/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import Button from '@material-ui/core/Button';
import { Trans, translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {|
  actionDrawerStore: TypeActionDrawerStore,
  asset: Object,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class ChangeAssetLocationError extends React.Component<*> {
  render(): React.Node {
    const { t, actionDrawerStore, asset }: TypeProps = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <h3>{t('general:error')}</h3>
          <Trans i18nKey="general:assets.messages.not_changed_location" parent="p">
            <u>{t('general:not')}</u>
          </Trans>
          <ul>
            <li>
              <b>{t('general:assets.labels.number')}: </b>
              {asset.asset_number}
            </li>
            <li>
              <b>{t('general:manufacturer')}: </b>
              {asset.manufacturer}
            </li>
            <li>
              <b>{t('general:model')}: </b>
              {asset.model}
            </li>
          </ul>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
